module.exports = __webpack_public_path__ + "static/media/LogicWedge5_1_1.9fa9ee08.png";